<template>
  <v-navigation-drawer
    app
    width="280"
    id="app-drawer"
    v-model="drawer"
    :right="$vuetify.rtl"
    :mini-variant="isMini"
    @mouseleave.native="mini = true"
    @mouseover.native="mini = false"
  >
    <!-- class="secondary" -->
    <v-layout class="fill-height" tag="v-list" column>
      <v-list-tile avatar class="py-2" multi-line>
        <v-list-tile-avatar tile color="" size="80">
          <v-img :src="branch_logo" height="55" contain />
          <!-- <v-img :src="APP_LOGO" contain /> -->
        </v-list-tile-avatar>
        <v-list-tile-content class="px-2">
          <!-- <v-list-tile-title class="body-2">{{ APP_NAME }}</v-list-tile-title> -->
          <!-- <v-list-tile-title class="body-1 mt-2 font-weight-bold"> -->
          <v-list-tile-title class="body-2 mt-2 font-weight-bold">
            <span class="primary--text px-1">(</span>{{ branch_name }}<span class="primary--text px-1">)</span>
          </v-list-tile-title>
          <!-- <v-list-tile-title class="body-2">Service Provider</v-list-tile-title> -->
        </v-list-tile-content>
      </v-list-tile>
      <v-divider class="mb-3" />

      <template v-for="(item, i) in items">
        <v-list-tile v-if="item.heading" align-center :key="i">
          <v-subheader class="f_12 px-0" :title="$t(item.heading)">{{ $t(item.heading) }} </v-subheader>
          <!-- <v-divider /> -->
        </v-list-tile>
        <v-list-group
          no-action
          :key="'c' + i"
          class=""
          v-model="item.model"
          v-else-if="item.children"
          :prepend-icon="item.group_icon"
        >
          <v-list-tile slot="activator" exact active-class="  nav-active">
            <v-list-tile-content>
              <v-list-tile-title class="IR_M f_12" :title="$t(item.title)">{{
                $t(item.title)
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            exact
            :key="i"
            :to="child.path"
            v-for="(child, i) in item.children"
            active-class="nav-active"
          >
            <v-list-tile-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="f_12" :title="$t(child.title)">{{
                $t(child.title)
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-list-tile
          exact
          v-else
          :key="'d' + i"
          class=""
          :to="item.path"
          active-class="nav-active"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="f_12" :title="$t(item.title)">{{
              $t(item.title)
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
      <v-spacer vertical></v-spacer>
      <v-list-tile avatar to="/profile">
        <v-list-tile-avatar>
          <img :src="user.image" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-text="user.name"></v-list-tile-title>
          <v-list-tile-sub-title
            v-text="user.branch.name"
          ></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-layout>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: ["appDrawer"],
  data: () => ({ mini: false, clipped: true }),

  computed: {
    isMini: ({ mini, clipped }) => mini && !clipped,
    items() {
      return this.$store.getters.getSidebarLinks;
    },
    drawer: {
      get: ({ appDrawer }) => appDrawer,
      set(val) {
        this.$emit("update:appDrawer", val);
      },
    },
    user() {
      return this.$store.getters["AuthModule/current_user"]["user"];
    },
  },
};
</script>


<style lang="scss">
.v-navigation-drawer .sidebar-color {
  background: rgba(27, 27, 27, 0.9) !important;
  padding: 0;
}
.img-container {
  transition: display 0.6s ease-in;
  margin-bottom: 60px;
}

.img-container .v-list__tile {
  height: 140px;
}

.img-container .avatar-wrapper {
  position: relative !important;
}

.img-container .avatar-center {
  position: absolute;
  height: 88px !important;
  width: 88px !important;
  bottom: -44px; /* 88/2 */
  cursor: pointer;
}

.img-container .avatar-center img {
  background: #fff; /* for transparent imgs*/
  border: 7px solid #393a3d; /*grey1*/
}

.nav-active {
  // // box-shadow: inset -6px 0 0 0 #429a5e;
  // border-radius: 4px;
  background: hsla(0, 0%, 57%, 0.08);
  box-shadow: inset 5px 0 0 #13aa52;
}

[dir="trl"].nav-active {
  // // box-shadow: inset -6px 0 0 0 #429a5e;
  // border-radius: 4px;
  background: hsla(0, 0%, 100%, 0.8);
  box-shadow: inset -5px 0 0 #13aa52;
}
</style>